"use client";

import { Moon, Sun } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useEffect, useState } from "react";
import { useTheme } from "next-themes";

interface ModeToggleProps {
  showLabel?: boolean;
  height?: number | string;
  width?: number | string;
  iconSize?: number;
  isTransparent?: boolean;
}
export function ModeToggle({
  showLabel = false,
  height = "auto",
  width = "auto",
  iconSize = 18,
  isTransparent = false,
}: ModeToggleProps) {
  const { theme, setTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  useEffect(() => setMounted(true), []);
  if (!mounted) return null;

  const isDark = theme === "dark";
  const iconColor = isTransparent ? "#fff" : isDark ? "#fff" : "#000";

  return (
    <Button
      variant="outline"
      onClick={() => setTheme(isDark ? "light" : "dark")}
      className={`border-0 bg-transparent shadow-none m-0 p-1 rounded ${
        showLabel ? "d-flex align-items-center gap-2" : ""
      }`}
      style={{ height, width, color: iconColor }}
    >
      {isDark ? (
        <Sun size={iconSize} color={iconColor} />
      ) : (
        <Moon size={iconSize} color={iconColor} />
      )}
      {showLabel && (
        <span className="theme-label text-sm" style={{ color: iconColor }}>
          {isDark ? "Light" : "Dark"}
        </span>
      )}
    </Button>
  );
}